exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-editor .value-xrange2 .widget-icon{background:url(\"/content/plugin-widget-value-xrange2/value-xrange-icon.svg\") no-repeat !important;opacity:1 !important}.widget-editor .value-xrange2:hover .widget-icon{filter:brightness(0.7)}.widget-editor .value-xrange2.active .widget-icon{filter:grayscale(1)}", ""]);

